import { render, staticRenderFns } from "./detailsDialog.vue?vue&type=template&id=60d8de3c&"
import script from "./detailsDialog.vue?vue&type=script&lang=js&"
export * from "./detailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports